var map = {
	"./ru": "ulq9",
	"./ru.js": "ulq9"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "hrl2";


//////////////////
// WEBPACK FOOTER
// ./~/moment/locale ru
// module id = hrl2
// module chunks = 14